export default "__VITE_ASSET__CxKESHnj__"